import { ArrowRightIcon } from '@heroicons/react/24/solid';
import React from 'react';
import LinkChd from '../../LinkChd';

type Props = {
  highlightedSection: any,
}

export default function HighlightedSection({ highlightedSection }: Props) {
  const sectionTitle = highlightedSection.titleOrLink
    ? highlightedSection.titleOrLink
    : highlightedSection.title;
  const { subLinks } = highlightedSection;

  return (
    <div className="flex flex-col py-5 pr-16">
      {typeof sectionTitle === 'string'
        && (
          <h6 className="font-semibold text-[16px] pt-[5px] pb-4 font-['Open_Sans'] text-dimGray text-wrap">
            {sectionTitle}
          </h6>
        )}
      <LinkChd
        link={sectionTitle}
        linkStyles="flex font-semibold pb-4 font-['Open_Sans'] text-darkCyan hover:text-blueLagoon"
        wrap
      >
        <span className="duration-300 transform hover:mr-2">{sectionTitle.title}</span>
        <ArrowRightIcon className="ml-2 duration-300 transform hover:ml-4" width={15} />
      </LinkChd>
      {subLinks && subLinks.map((item: any) => (
        <LinkChd
          key={item.id}
          linkStyles="font-semibold text-[20px] pb-[15px] font-['Open_Sans'] text-black hover:text-darkCyan text-wrap"
          link={item}
          wrap
        >
          <div className="leading-[24px]">{item.title}</div>
        </LinkChd>
      ))}
    </div>
  );
}
